import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  GovernanceGroupMembership,
  GovernanceGroupMembershipExtensionSchema,
  OrgExtensionSchema,
  OrgName,
  OwnerMember,
  OwnershipExtensionSchema,
  validateCustomGovernanceGroupMembership,
  validateOwnership,
} from './GovernanceGroupMembership';

export const GovernanceGroupMembershipFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    component: GovernanceGroupMembership,
    name: 'GovernanceGroupMembershipField',
    validation: validateCustomGovernanceGroupMembership,
    schema: GovernanceGroupMembershipExtensionSchema,
  }),
);

export const OrgMembershipFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'OrgMembershipField',
    component: OrgName,
    schema: OrgExtensionSchema,
  }),
);

export const OwnershipFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    component: OwnerMember,
    name: 'OwnerMembershipField',
    validation: validateOwnership,
    schema: OwnershipExtensionSchema,
  }),
);
